import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'theme-ui';
import useCTAStyle from '~/hooks/components/use-cta-style';

const CTAButton = ({
  baseColor = 'White',
  size = 'Medium',
  variant = 'Outline',
  forwardSx = {},
  disableDisabledStyle = false,
  children,
  ...props
}) => {
  const CTAStyle = useCTAStyle({ baseColor, variant, size, disableDisabledStyle, forwardSx });

  return (
    <Button
      sx={{
        ...CTAStyle,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default CTAButton;

CTAButton.propTypes = {
  baseColor: PropTypes.oneOf(['White', 'Black']).isRequired,
  size: PropTypes.oneOf(['Small', 'Medium', 'Large']).isRequired,
  variant: PropTypes.oneOf(['Outline', 'Filled']).isRequired,
  children: PropTypes.node.isRequired,
};
